import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import { styled } from '@mui/system';
import productData from '../../assets/produkty.json';
import recipesData from '../../assets/przepisy.json';
import ItemsGrid from './ItemsGrid';
import SearchBar from './SearchBar';
import ContentSection from './ContentSection';
import ContentSectionSkeleton from './ContentSectionSkeleton';

const SectionWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

const Root = styled(Container)(({ theme }) => ({
  padding: theme.spacing(2, 1),
}));

const Header = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  fontWeight: 'bold',
  fontSize: theme.typography.h4.fontSize,
  lineHeight: 1.2,
  color: theme.palette.text.primary,
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  margin: theme.spacing(2, 0),
}));

const getRandomItems = (items, count) => {
  const shuffled = items.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const SearchInfoPage = ({ title, isLoading, searchPlaceholder, contentSections, productId, isRecipes, error, setError }) => {
  const navigate = useNavigate();
  const products = isRecipes ? (recipesData.filter((product) => !!product.id)) : (productData.filter((product) => !!product.id));
  const [randomItems, setRandomItems] = useState([]);
  const [searchResults, setSearchResults] = useState([]);

  products.sort((a, b) => a.id - b.id);
  const handleSearch = (results) => {
    setSearchResults(results);
  };

  useEffect(() => {
    setRandomItems(getRandomItems(products, 12));
  }, [productId, contentSections]);

  const mainImageSrc = isRecipes ? `/images/recipes/${productId}.jpeg` : `/images/products/${productId}.jpeg`;

  if (isLoading) {
    window.scrollTo(0, 0);
  }

  return (
    <Root>
      {isLoading ? (
        <ContentSectionSkeleton />
      ) : (
        contentSections ? (
          <ContentSection contentSections={contentSections} mainImageSrc={mainImageSrc} />
        ) : (
          <>
            <Header>{title}</Header>
            <SearchBar error={error} setError={setError} products={products} isRecipes={isRecipes} searchPlaceholder={searchPlaceholder} onSearch={handleSearch} />
            {error && <ErrorMessage>{error}</ErrorMessage>}
            {!contentSections && !error && <ItemsGrid items={searchResults.length === 0 ? products : searchResults} isRecipes={isRecipes} />}
          </>
        )
      )}
    </Root>
  );
};

export default SearchInfoPage;